import React from 'react';
import './IconWrapper.css';

/**
 * Wrapper pour icônes avec gradients et effets
 *
 * @param {ReactNode} children - L'icône SVG à wrapper
 * @param {string} size - Taille: xs, sm, md, lg, xl
 * @param {string} variant - Variante de couleur: primary, cloud, ai, secure, mobile
 * @param {boolean} glow - Activer l'effet de lueur
 * @param {boolean} animate - Activer l'animation flottante
 */
const IconWrapper = ({
  children,
  size = 'md',
  variant = 'primary',
  glow = false,
  animate = false,
  className = ''
}) => {
  const sizeClasses = {
    xs: 'w-12 h-12',
    sm: 'w-14 h-14',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  return (
    <div
      className={`
        icon-wrapper
        ${sizeClasses[size]}
        gradient-${variant}
        ${glow ? 'icon-glow icon-glow-' + variant : ''}
        ${animate ? 'icon-float' : ''}
        rounded-xl
        flex
        items-center
        justify-center
        transition-all
        duration-300
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default IconWrapper;
